import React from "react";
import "./HeroSection.css";
import { Content } from "./WhoWeAre";
import { VideoWrapper } from "../pages/ForAssociates";
import styled from "styled-components";
import CountUp from "react-countup";

const HeroSection = ({ openModal }) => {
  return (
    <div className="hero-section-wrapper">
      <ContentWrapper>
        <div className="content-container">
          <Content>
            <h1 style={{ lineHeight: "40px" }}>
              <b>
                Understand <span> Insurance</span>
                <br /> with <span>Confidence</span>
              </b>
            </h1>
            <p className="title-description">
              Insurance can sometimes feel complicated because of technical
              terms and complex policy structures. Wealthies aims to simplify
              insurance awareness by helping individuals understand insurance
              concepts and connect with licensed insurance professionals.
            </p>{" "}
            <p>
              Through educational guides, advisor connections, and support
              initiatives like Wealthies Shield, we help individuals explore
              insurance options with greater clarity.{" "}
            </p>
            <div className="trust-container">
              <div className="google-review">
                <div>
                  <img
                    src="/assets/google_logo.png"
                    alt="Google"
                    className="google-logo"
                  />
                </div>
                <div>
                  <div className="review-content">
                    <span style={{ fontWeight: "bolder" }}>4.9</span>
                    <div className="rating-stars">
                      <i className="fa-solid fa-star"></i>
                      <i className="fa-solid fa-star"></i>
                      <i className="fa-solid fa-star"></i>
                      <i className="fa-solid fa-star"></i>
                      <i className="fa-solid fa-star"></i>
                    </div>
                  </div>

                  <p className="ratings-text">Ratings on Google</p>
                </div>
              </div>
              <div className="google-review">
                <div>
                  <img
                    src="/assets/trust.png"
                    alt="trustpilot"
                    className="trust-img"
                  />
                </div>
                <div>
                  <div className="rating-stars">
                    <b>Licensed Insurance</b>
                  </div>
                  <p className="ratings-text">Advisor Network</p>
                </div>
              </div>
            </div>
          </Content>
          <CTAButtonWrapper>
            <CTAButton onClick={openModal}>
              Book a consultation. Free!
            </CTAButton>
          </CTAButtonWrapper>
        </div>
        <VideoWrapper>
          <video width="640" height="360" loop autoPlay muted playsInline>
            <source src="/assets/home.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          <div className="stats-container">
            <div className="stat-box">
              <h6 className="counter">
                <CountUp end={3000} duration={2} />+
              </h6>
              <p>Monthly Interactions</p>
            </div>

            <div className="stat-box">
              <h6 className="counter">
                <CountUp end={8000} duration={2} />+
              </h6>
              <p>Queries Assisted</p>
            </div>

            <div className="stat-box advisor">
              <h6 className="counter">Growing</h6>
              <p>Advisor Network</p>
            </div>
          </div>
        </VideoWrapper>
      </ContentWrapper>
    </div>
  );
};

export default HeroSection;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 5%;
  flex-wrap: wrap;
  margin-top: 100px;

  @media (max-width: 900px) {
    flex-direction: column;
    align-items: center;
    text-align: center;
    margin-top: 5px;

    h1 {
      font-size: 30px;
    }

    p {
      text-align: left;
    }
  }
`;

export const CTAButtonWrapper = styled.div`
  width: 100%;
  margin-top: 30px;
  margin-bottom: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const CTAButton = styled.button`
  /* background: #344e41;
  color: #ffffff;
  border: none;
  padding: 0.75rem 1.5rem;
  font-size: 1rem;
  border-radius: 4px;
  cursor: pointer;

  &:hover {
    background: #344e41;
  } */

  /* <button class="button-28" role="button">Button 28</button> */

  /* CSS */
  /* .btn-slide-1,
  .btn-slide-2 { */
  appearance: none;
  background-color: #005f73;
  border: 2px solid #005f73;
  border-radius: 10px;
  box-sizing: border-box;
  color: #ffffff;
  cursor: pointer;
  display: inline-block;
  font-family:
    Roobert,
    -apple-system,
    BlinkMacSystemFont,
    "Segoe UI",
    Helvetica,
    Arial,
    sans-serif,
    "Apple Color Emoji",
    "Segoe UI Emoji",
    "Segoe UI Symbol";
  font-size: 16px;
  font-weight: 600;
  line-height: normal;
  margin-bottom: 10px;
  min-height: 60px;
  min-width: 0;
  outline: none;
  padding: 0.75rem 1.5rem;

  text-align: center;
  text-decoration: none;
  transition: all 300ms cubic-bezier(0.23, 1, 0.32, 1);
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  /* width: 100%; */
  will-change: transform;
  /* } */

  &:disabled {
    pointer-events: none;
  }

  &:hover {
    color: #fff;
    background-color: #005f73;
    box-shadow: rgba(0, 0, 0, 0.25) 0 8px 15px;
    transform: translateY(-2px);
  }

  &:active {
    box-shadow: none;
    transform: translateY(0);
  }
`;
